export const MAX_PURCHASE_QUANTITY = 100;
export const FEED_ANIMATION_DURATION = 500;
export const GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT = 30;
export const GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT = 30;
export const LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT = 72e5;
export const MAX_RETRY_COUNT_PER_REQUEST = 15;
export const REQUEST_ATTEMPT_DEFAULT = 1;
export const REQUEST_BACKOFF_MIN_SLEEP_MS_DEFAULT = 1e4;
export const REQUEST_BACKOFF_SCALE_FACTOR_DEFAULT = 3;
export const REQUEST_BACKOFF_MAX_SLEEP_MS_DEFAULT = 3e5;
export const CoreStrings = {
  ee: "Braze must be initialized before calling methods.",
  $e: "logCustomEvent",
  Ku: "setCustomUserAttribute",
};
